import { render, staticRenderFns } from "./GoodsAction.vue?vue&type=template&id=e95f64cc&scoped=true&"
import script from "./GoodsAction.vue?vue&type=script&lang=js&"
export * from "./GoodsAction.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAction.vue?vue&type=style&index=0&id=e95f64cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95f64cc",
  null
  
)

component.options.__file = "src/components/goods-action/GoodsAction.vue"
export default component.exports